import { type AppHostNames, appHosts } from '../appHosts';
import { Stands, type StandsKeys } from '../Stands';

function getDomain(url: string) {
	return new URL(url).host.match(/(?<domain>[a-zA-Z0-9]+\.[a-z]+$)/)?.groups
		?.domain;
}
export function getCurrentStand(): StandsKeys {
	const standsKeys: StandsKeys[] = Object.keys(Stands) as StandsKeys[];
	for (const appHost of Object.keys(appHosts) as AppHostNames[]) {
		const stand = standsKeys.find(
			(stand) =>
				getDomain(appHosts[appHost][stand]) ===
				getDomain(location.origin),
			// ||
			// appConfig[stand].partnersList.includes(location.origin),
		);
		if (stand) {
			return stand;
		}
	}
	return String(process.env.stand) as StandsKeys;
}
